import { render, staticRenderFns } from "./messageDashTeacher.vue?vue&type=template&id=7496d482&"
import script from "./messageDashTeacher.vue?vue&type=script&lang=js&"
export * from "./messageDashTeacher.vue?vue&type=script&lang=js&"
import style0 from "./messageDashTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports